/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/

// Text content map for product add page - to be replaced with actual content keys/translations
export const textMap = {
  // Page level
  pageTitle: "Add product",
  editPageTitle: "Edit Product",
  btnSaveAndCreate: "Save and create",
  btnSaveAndUpdate: "Save and update",
  btnDelist: "Delist",
  btnListAgain: "List Again",
  sectionBasicInformation: "Basic information",
  sectionSpecifications: "Specifications",
  sectionVariations: "Variations",
  sectionShipping: "Shipping",
  variationPlaceholder: "Variation fields will go here",

  // Basic Information Form
  requiredPhoto: "At least 1 product photo is required",
  dragToReorder: "Drag to reorder",
  labelProductImages: "Product Images",
  labelProductVideo: "Product Video",
  addImage: "Add image",
  addProductPhoto: "Add Product Photo",
  imageCounter: "({count}/{max})",
  labelName: "Name",
  placeholderName: "Item name",
  requiredName: "Name is required",
  labelCategory: "Grab Category",
  placeholderCategory: "Select Category",
  requiredCategory: "Grab Category is required",
  labelParentSku: "Parent SKU Number",
  placeholderParentSku: "Enter Parent SKU Number if any",
  labelDescription: "Description",
  placeholderDescription: "Add item description",

  // Specifications Form
  emptyStateSpecifications:
    "Please select a category first to see specifications.",
  specSetByVariations: "Set by Variations",
  labelBrand: "Brand",
  placeholderBrand: "Name",
  labelMaterial: "Material",
  placeholderMaterial: "Select Category",
  labelPiecesCount: "No. of pieces included in this item",
  placeholderPiecesCount: "1",
  helperTextPiecesCount: "E.g. 12 bottles packed in to this item",
  labelVolumeWeight: "Volume/weight per unit",
  placeholderVolumeWeight: "E.g. 100ml",
  unitMl: "ml",
  unitL: "l",
  unitG: "g",
  unitKg: "kg",
  unitCm: "cm",

  // Shipping Form
  labelDifferentWeightForVariations:
    "Different weight/dimensions for variations",
  labelWeight: "Weight",
  labelDimensionSize: "Parcel Size",
  labelShippingFee: "Shipping Fee",
  shipping3plDescription: "3PL Logistics",
  shipping3plName: "Delivered by Seller",
  shippingGrabExpressDescription: "GrabExpress",
  shippingGrabExpressName: "Real-time Grab Delivery",

  // Variations Form
  btnAddVariation: "Add Variation",
  variationCounter: "({count}/2)",
  emptyStateVariationsSelectCategory:
    "This category does not support variations.",
  emptyStateVariations:
    'No variations added. Click "Add Variation" to create product variants.',

  // Variation Card
  variationTitle: "Variation {number}",
  labelVariationType: "Variation Type",
  placeholderVariationType: "Select variation type",
  labelOptions: "Options",
  placeholderCustomOption: "Enter custom {type}",
  placeholderSelectOption: "Select {type}",
  optionCustom: "Custom",
  optionCustomSuffix: "(Custom)",
  btnAddOption: "Add Option",
  optionCounter: "({count}/{max})",
  charCounter: "{count}/{max}",

  // Variation Types
  variationTypeFlavor: "Flavor",
  variationTypeSetName: "Set Name",
  variationTypeNumberOfItems: "Number of Items",
  variationTypeSize: "Size",
  variationTypeColor: "Color",
  variationTypeUnitCount: "Unit Count",
  variationTypeUnitCountType: "Unit Count Type",

  // Variation Preset Options - Flavor
  flavorVanilla: "Vanilla",
  flavorChocolate: "Chocolate",
  flavorStrawberry: "Strawberry",
  flavorMint: "Mint",
  flavorCaramel: "Caramel",
  flavorOriginal: "Original",

  // Variation Preset Options - Set Name
  setNameBasic: "Basic Set",
  setNamePremium: "Premium Set",
  setNameDeluxe: "Deluxe Set",
  setNameStarter: "Starter Set",
  setNameComplete: "Complete Set",

  // Variation Preset Options - Number of Items
  numItems1: "1 Piece",
  numItems2: "2 Pieces",
  numItems3: "3 Pieces",
  numItems5: "5 Pieces",
  numItems10: "10 Pieces",

  // Variation Preset Options - Size
  sizeXS: "XS",
  sizeS: "S",
  sizeM: "M",
  sizeL: "L",
  sizeXL: "XL",
  sizeXXL: "XXL",
  sizeFree: "Free Size",

  // Variation Preset Options - Color
  colorRed: "Red",
  colorBlue: "Blue",
  colorGreen: "Green",
  colorYellow: "Yellow",
  colorBlack: "Black",
  colorWhite: "White",
  colorPink: "Pink",
  colorPurple: "Purple",
  colorOrange: "Orange",
  colorGrey: "Grey",

  // Variation Preset Options - Unit Count
  unitCount1: "1",
  unitCount2: "2",
  unitCount3: "3",
  unitCount5: "5",
  unitCount10: "10",
  unitCount12: "12",
  unitCount24: "24",

  // Variation Preset Options - Unit Count Type
  unitCountTypePack: "Pack",
  unitCountTypeBox: "Box",
  unitCountTypeBottle: "Bottle",
  unitCountTypeCan: "Can",
  unitCountTypeBag: "Bag",
  unitCountTypePiece: "Piece",

  // Notification messages
  productCreated: "Product created successfully",
  productUpdated: "Product updated successfully",
  productDelisted: "Product delisted successfully",
  productListed: "Product listed successfully",

  // Variation Table
  tableTitle: "Variation List",
  columnImage: "Image",
  columnPrice: "Price",
  columnGtin: "GTIN",
  columnSku: "SKU",
  columnStock: "Stock",
  columnActive: "Active",
  tooltipVariationActiveDisabled:
    "Re-list the product to enable individual variation status",
  columnWeight: "Weight",
  columnDimensionSize: "Parcel Size",
  placeholderDimensionSizeL: "L",
  placeholderDimensionSizeW: "W",
  placeholderDimensionSizeH: "H",
  placeholderEnter: "Enter",
  placeholderStock: "0",
  addVariationImage: "Add Variation Image",
  pricePrefix: "SGD",
  errorMaxVariationsReached:
    "Maximum {max} variations reached. Remove options from the other variation type to add more here.",
  variationCount: "{count} / {max} variations",
  requiredPrice: "Price is required",
  invalidPrice: "You can only enter a positive number",
  requiredStock: "Stock is required",
  requiredWeight: "Weight is required",
  requiredDimension: "Dimension is required",
  invalidGtinNumeric: "GTIN should only contain digits",
  invalidGtinExceedDigits: "GTIN must be no longer than 20 digits",

  // Delist confirmation modal (triggered when all variations are inactive on save)
  delistConfirmTitle: "This will delist the product",
  delistConfirmContent:
    "Making the last active variation inactive will delist this product. Do you want to proceed?",
  delistConfirmOk: "Proceed",
  delistConfirmCancel: "Cancel",

  // Update status confirmation modal (triggered by Delist / List Again button)
  delistStatusConfirmTitle: "Delist this product?",
  delistStatusConfirmContent: "Are you sure you want to delist this product?",
  listAgainStatusConfirmTitle: "List Again this product?",
  listAgainStatusConfirmContent:
    "Are you sure you want to list again this product?",
  updateStatusConfirmOk: "Proceed",
  updateStatusConfirmCancel: "Cancel",
}

// Variation limits
export const MAX_OPTIONS_PER_VARIATION = 20
export const MAX_TOTAL_VARIATIONS = 100

export const WEIGHT_UNIT = "kg"
export const DIMENSION_UNIT = "cm"

export const DEFAULT_STATUS = {
  ACTIVE: "ACTIVE",
  DEACTIVATED: "DEACTIVATED",
  SOFTDELETED: "SOFTDELETED",
  ARCHIVED: "ARCHIVED",
}

export const ATTRIBUTE_STATUS = {
  ENABLED: "Enabled",
  DISABLED: "Disabled",
}

export const NUMERICAL_FIELD_DEFAULTS = {
  MIN: 0,
  MAX: 1000,
  DECIMAL_PLACES: 2,
}
